import React, { useState, useEffect, useRef, useImperativeHandle } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../../actions/ticket-action';
import PropTypes from 'prop-types';
import * as service from '../../services/sTicket/ticket.service';



const EditForm = React.forwardRef(({ preSetData, actionsConnect }, ref) => {
  const [formData, setFormData] = useState({
    id: '',
    subject: '',
    category: '',
    assignee: '',
    priority: '',
    status: '',
    categories: ['Billing', 'Dev', 'Marketing', 'Service'],
    assignees: ['Erwin', 'Jessica', 'George', 'Jose', 'Luke'],
    priorities: ['Normal', 'Low', 'Medium', 'High'],
    statusOpt: ['Open', 'Pending', 'Processing', 'Closed'],
  });

  useEffect(() => {
    const {
      id, subject, category, assignee, priority, status,
    } = preSetData;
    setFormData({
      ...formData,
      id,
      subject,
      category,
      assignee,
      priority,
      status,
    });
  }, [preSetData]);

  // Define una referencia para el formulario
  const formRef = useRef(null);

  // Método para manejar el cambio en los campos del formulario
  const handleChange = (e) => {
    const name = e.target.id;
    setFormData({
      ...formData,
      [name]: e.target.value,
    });
  };

  // Método para guardar los cambios del formulario
  const handleSaveItem = (e) => {
    e.preventDefault();
    const { subject } = formData;
    if (subject === '') {
      alert("Subject can't be empty");
    } else {
      const {
        id, category, assignee, priority, status,
      } = formData;
      const savedItem = {
        id,
        subject,
        category,
        assignee,
        priority,
        status,
        update: true,
      };


      service.updateTicket(savedItem.id, savedItem).then(async (response) => {
        const savedItem = response.data.data;
        actionsConnect.saveItem(savedItem);

      }).catch(() => {

      });

    }
  };

  // Método para ejecutar la lógica de submit
  const handleFormSubmit = () => {
    if (formRef.current) {
      handleSaveItem({ preventDefault: () => { } });
    }
  };

  // Exponer el método handleFormSubmit mediante useImperativeHandle
  useImperativeHandle(ref, () => ({
    handleFormSubmit: handleFormSubmit
  }));

  const cancelEdit = () => {
    const {
      subject, category, assignee, priority, status,
    } = preSetData;
    setFormData({
      ...formData,
      subject,
      category,
      assignee,
      priority,
      status,
    });
  };

  const optionGenerator = (optionList) => {
    return optionList.map(opt => (
      <option key={opt} value={opt}>
        {opt}
      </option>
    ));
  };

  const {
    id,
    subject,
    category,
    assignee,
    priority,
    status,
    categories,
    assignees,
    priorities,
    statusOpt,
  } = formData;

  return (
    <div className="container-sm">
      <form ref={formRef} onSubmit={handleSaveItem}>
        <div className="modal-body">
          <div className="form-group">
            <label htmlFor="item-id">Id</label>
            <input
              className="form-control"
              id="item-id"
              value={id}
              readOnly
            />
          </div>
          <div className="form-group">
            <label htmlFor="subject">Subject</label>
            <textarea
              className="form-control"
              id="subject"
              rows="3"
              value={subject}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label htmlFor="category">Category</label>
            <select
              className="form-control"
              id="category"
              value={category}
              onChange={handleChange}
            >
              {optionGenerator(categories)}
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="assignee">Assignee</label>
            <select
              className="form-control"
              id="assignee"
              value={assignee}
              onChange={handleChange}
            >
              {optionGenerator(assignees)}
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="priority">Priority</label>
            <select
              className="form-control"
              id="priority"
              value={priority}
              onChange={handleChange}
            >
              {optionGenerator(priorities)}
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="status">Status</label>
            <select
              className="form-control"
              id="status"
              value={status}
              onChange={handleChange}
            >
              {optionGenerator(statusOpt)}
            </select>
          </div>
        </div>
        <div className="modal-footer">

        </div>
      </form>
    </div>
  );
});

EditForm.propTypes = {
  actionsConnect: PropTypes.object.isRequired,
};

const mapDispatchToProps = dispatch => ({
  actionsConnect: bindActionCreators(actions, dispatch),
});

export default connect(null, mapDispatchToProps, null, { forwardRef: true })(EditForm);
